import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

import NavBar from '../components/NavBar';
import FrTextInput from '../components/FrTextInput';
import UserOptions from '../components/UserOptions';
import FrSelect from '../components/FrSelect';
import FrLoading from '../components/FrLoading';

import api from '../services/api';
import { paramsToObject, dateSql, getUserCode } from '../utils/functions';
import { colors } from '../utils/vars';
import { mCPF, mVAL, mValidade, mTel, mCEP } from '../utils/masks'
import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import FrDatePicker from '../components/FrDatePicker'
import consultaCep from '../services/consultaCep'
import FrTableReg from '../components/FrTable'
import Dialog from '@material-ui/core/Dialog';
import RegContratos from './RegContratosModal'
import RegCliente from './RegClientesContratos'

const swal = withReactContent(Swal)

function Contratos_Empresas(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboSed, setComboSed] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboTco, setComboTco] = useState([{ value: '', display: '' }])
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [comboEmp, setComboEmp] = useState([{ value: '', display: '' }])
  const [dataCto, setDataCto] = useState([{ value: '', display: '', nome: '' }])
  const [showModal, setShowModal] = useState(false)
  const [filterText, setFilterText] = useState('')
  const [showModalContratos, setShowModalContratos] = useState(false)
  const [pk_cto, setPk_Cto] = useState('')
  const [pk_cli, setPk_Cli] = useState('')

  const columnsCto = [{ id: 'pk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
  { id: 'nomecli', numeric: false, label: 'Beneficiário', align: 'left', minWidth: 90 },
  { id: 'titular', numeric: false, label: 'Tit/Dep', align: 'left', minWidth: 90 },
  { id: 'data_inicio', date: true, numeric: false, label: 'Data Início', align: 'left', minWidth: 100 },
  { id: 'data_fim', date: true, numeric: false, label: 'Data Fim', align: 'left', minWidth: 100 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      try {
        swal.fire({
          html: <FrLoading text="Carregando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        const urlParams = new URLSearchParams(window.location.search);
        let query = paramsToObject(urlParams)

        if (query.codigo > 0) {
          setEnableEdit(await api.getAcessos('Contratos_Empresas', 'Alteracao'))
        } else {
          setEnableEdit(await api.getAcessos('Contratos_Empresas', 'Inclusao'))
        }

        setComboSed(await api.getComboDataWhere('sedes', "?fk_usu=" + getUserCode()))
        setComboTco(await api.getComboData('tipo_contrato'))
        setComboCid(await api.getComboData('cidades'))
        setComboEmp(await api.getComboData('empresas'))

        if (query.codigo > 0) {
          setUpdateType(true)
          api.get('/contratos_empresas?pk_cte=' + query.codigo).then(async r => {
            if (r.data[0]) {
              if (r.data[0].valor_titular)
                r.data[0].valor_titular = mVAL(r.data[0].valor_titular * 100)

              if (r.data[0].valor_dependente)
                r.data[0].valor_dependente = mVAL(r.data[0].valor_dependente * 100)

              setData(r.data[0])

              api.get('/contratos_empresas/contratos?fk_emp=' + r.data[0].fk_emp).then(r => {
                if (r.data.length > 0)
                  setDataCto(r.data)

                swal.close()
              })
            } else {
              swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
                .then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
            }
          })
        } else swal.close()

      } catch (error) {

      }
    }

    fetchData()
  }, [])

  function teste(pk_cli) {
    // alert(pk_cli)
    setPk_Cli(pk_cli)
    setShowModalContratos(true)
  }

  function consistData(data) {
    let required = [
      'fk_emp',
      'data_inicio',
      'fk_tco',
      'fk_fpg',
      'dia_venc'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr == 'fk_emp')
        fieldName = 'Empresa'

      if (curr == 'fk_tco')
        fieldName = 'Tipo'

      if (curr == 'data_inicio')
        fieldName = 'Data Início'

      if (curr == 'fk_fpg')
        fieldName = 'Forma de Pagamento'

      if (curr == 'dia_venc')
        fieldName = 'Dia Vcto'


      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Contrato com mensalidade de R$ " + data.mensalidade + "! Confirma?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.data_venc_cartao = dateSql('01/' + auxValues.venc_cartao)
        auxValues.fk_usu = getUserCode()
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          salvarContrato()

        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }


  function salvarContrato() {
    const auxValues = { ...data };
    auxValues.data_venc_cartao = dateSql('01/' + auxValues.venc_cartao)
    auxValues.fk_usu = getUserCode()

    if (updateType) {
      api.post('/contratos_empresas/edit', auxValues).then(r => {
        if (r.status === 200) {
          swal.fire({
            title: 'Registro Alterado',
            text: "O registro foi alterado com sucesso!",
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
        } else {
          swal.fire({
            title: 'Erro!',
            text: "O registro não foi alterado!",
            icon: 'warning',
          })
        }
      })
    } else {
      api.post('/contratos_empresas/add', auxValues).then(r => {
        if (r.status === 200) {
          swal.fire({
            title: 'Registro Adicionado',
            text: "O registro foi adicionado com sucesso!",
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
        } else {
          swal.fire({
            title: 'Erro!',
            text: "O registro não foi adicionado!",
            icon: 'warning',
          })
        }
      })
    }
  }


  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }


  useEffect(() => {
    const fetchData = async () => {
      try {
        const auxValues = { ...data };
        if (data.fk_tco > 0) {
          await api.get('/tipo_contrato?pk_tco=' + data.fk_tco).then(async r => {
            if (r.data[0]) {
              setComboFpg(await api.getComboDataWhere('formas_pagamento', "?fk_tpf=" + r.data[0].fk_tpf))
              auxValues.fk_tpf = r.data[0].fk_tpf
              setData(auxValues)
            }
          })
        }
      } catch (error) {

      }

    }

    fetchData()
  }, [data.fk_tco])


  const handleChange = async (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'valor_titular':
      case 'valor_dependente':
        auxValues[e.target.name] = e.target.value ? mVAL(e.target.value, 2) : '';
        break;
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  const handleBlur = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'valor_titular':
      case 'valor_dependente':
        auxValues[e.target.name] = e.target.value ? mVAL(e.target.value, 2) : '';
        break;

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  }

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
      if (!r.data.erro) {
        auxValues.endereco_titular_conta = r.data.logradouro
        api.get('/cidades?descricao=' + r.data.localidade).then(res => {
          if (res.data.length > 0) {
            auxValues.fk_cid_titular_conta = res.data[0].pk_cid
          }
          setData(auxValues)
          swal.close()
        })
      } else {
        swal.close()
        swal.fire('CEP Inválido!', 'CEP Não encontrado nos registros!', 'warning')
      }
    })
  }

  function setCto(cto) {
    api.post("/contratos_empresas/incluiCto?pk_cto=" + cto + '&fk_emp=' + data.fk_emp).then(r => {
      if (r.status === 200) {
        api.get('/contratos_empresas/contratos?fk_emp=' + data.fk_emp).then(r => {
          if (r.data.length > 0)
            setDataCto(r.data)
        })
      }
    })
  }


  async function incluiCto(e) {
    e.preventDefault();
    if (!data.fk_emp) {
      swal.fire('Empresa não informada!', 'Informe a empresa!', 'warning')
    } else
      setShowModal(true)
  }


  return (
    <div className="defaultReg">

      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Contrato</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrSelect
            value={data.fk_emp || ''}
            onChange={handleChange}
            name="fk_emp"
            id="fk_emp"
            label='Empresa'
            data={comboEmp}
            style={{ width: 425 }}
          />

          <FrDatePicker
            value={(data.data_inicio || '').split('T')[0]}
            name="data_inicio"
            id="data_inicio"
            color="#49573B"
            label="Início Contrato"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
          />

          <FrDatePicker
            value={(data.data_fim || '').split('T')[0]}
            name="data_fim"
            id="data_fim"
            color="#49573B"
            label="Final Contrato"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
          />


          <br />
          <FrTextInput
            value={data.valor_titular || ''}
            style={{ width: 120 }}
            name="valor_titular"
            id="valor_titular"
            color="#333333"
            label="Valor Titular"
            variant="outlined"
            size="small"
            onChange={handleChange}
            onBlur={handleBlur}
          // disabled
          />

          <FrTextInput
            value={data.valor_dependente || ''}
            style={{ width: 130 }}
            name="valor_dependente"
            id="valor_dependente"
            color="#333333"
            label="Valor Dependente"
            variant="outlined"
            size="small"
            onChange={handleChange}
            onBlur={handleBlur}
          // disabled
          />

          <br />
          <FrSelect
            value={data.fk_tco || ''}
            onChange={handleChange}
            name="fk_tco"
            id="fk_tco"
            label='Tipo'
            data={comboTco}
            style={{ width: 180 }}
          />
          <FrSelect
            value={data.fk_sed || ''}
            onChange={handleChange}
            name="fk_sed"
            id="fk_sed"
            label='Unidade'
            data={comboSed}
            style={{ width: 200 }}
          />

          <br />
          <FrTextInput
            value={data.dia_venc || ''}
            style={{ width: 100 }}
            name="dia_venc"
            id="dia_venc"
            color="#333333"
            label="Dia Vcto"
            variant="outlined"
            size="small"
            onChange={handleChange}
          />

          <FrSelect
            value={data.fk_fpg || ''}
            onChange={handleChange}
            name="fk_fpg"
            id="fk_fpg"
            label='Forma de Pagamento'
            data={comboFpg}
            style={{ width: 250 }}
          />


          <br />
          <div hidden={data.fk_tpf != 2}>

            <strong>Dados da Conta</strong>

            <hr width="100%" size="50" color="#083c7c" />
            <br />

            <FrTextInput
              value={data.agencia || ''}
              style={{ width: 100 }}
              name="agencia"
              id="agencia"
              color="#333333"
              label="Agência"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={5}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              value={data.conta || ''}
              style={{ width: 150 }}
              name="conta"
              id="conta"
              color="#333333"
              label="Conta"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={13}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              value={data.nome_titular_conta || ''}
              style={{ width: 400 }}
              name="nome_titular_conta"
              id="nome_titular_conta"
              color="#333333"
              label="Titular Conta"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={100}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              value={mCPF(data.cpf_titular_conta) || ''}
              style={{ width: 150 }}
              name="cpf_titular_conta"
              id="cpf_titular_conta"
              color="#333333"
              label="CPF Titular Conta"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={20}
              hidden={data.fk_tpf != 2}
            />
            {data.fk_tpf == 2 ? <br /> : <></>}

            <FrTextInput
              maxLength='10'
              value={data.cep_titular_conta ? mCEP(data.cep_titular_conta) : ''}
              onChange={handleChange}
              name="cep_titular_conta"
              id="cep_titular_conta"
              color="#389492"
              label="CEP"
              variant="outlined"
              size="small"
              onBlur={handleCep}
              style={{ width: 110 }}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              maxLength='100'
              value={data.endereco_titular_conta || ''}
              onChange={handleChange}
              name="endereco_titular_conta"
              id="endereco_titular_conta"
              color="#389492"
              label="Endereço"
              variant="outlined"
              size="small"
              style={{ width: 450 }}
              hidden={data.fk_tpf != 2}
            />

            <FrSelect
              value={data.fk_cid_titular_conta || ''}
              onChange={handleChange}
              name="fk_cid_titular_conta"
              id="fk_cid_titular_conta"
              label='Cidade'
              data={comboCid}
              style={{ width: 200 }}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              maxLength='14'
              value={data.fone_titular_conta ? mTel(data.fone_titular_conta) : ''}
              onChange={handleChange}
              name="fone_titular_conta"
              id="fone_titular_conta"
              color="#389492"
              label="Fone Titular Conta"
              variant="outlined"
              size="small"
              style={{ width: 180 }}
              hidden={data.fk_tpf != 2}
            />
          </div>

          <div hidden={data.fk_tpf != 1}>
            <strong>Dados do Cartão</strong>
            <hr width="100%" size="50" color="#083c7c" />
            <br />

            <FrTextInput
              value={data.numero_cartao || ''}
              style={{ width: 150 }}
              name="numero_cartao"
              id="numero_cartao"
              color="#333333"
              label="Nº Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={20}
              hidden={data.fk_tpf != 1}
            />
            <FrTextInput
              value={data.cod_seguranca_cartao || ''}
              style={{ width: 90 }}
              name="cod_seguranca_cartao"
              id="cod_seguranca_cartao"
              color="#333333"
              label="CVC"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={3}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={mValidade(data.venc_cartao) || ''}
              style={{ width: 180 }}
              name="venc_cartao"
              id="venc_cartao"
              color="#333333"
              label="Vcto Cartão (mm/aaaa)"
              variant="outlined"
              size="small"
              onChange={handleChange}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={data.vencimento_fatura_cartao || ''}
              style={{ width: 100 }}
              name="vencimento_fatura_cartao"
              id="vencimento_fatura_cartao"
              color="#333333"
              label="Vcto Fatura"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={2}
              hidden={data.fk_tpf != 1}
            />
            <br />
            <FrTextInput
              value={data.titular_cartao || ''}
              style={{ width: 400 }}
              name="titular_cartao"
              id="titular_cartao"
              color="#333333"
              label="Titular Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={100}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={mCPF(data.cpf_titular_cartao) || ''}
              style={{ width: 150 }}
              name="cpf_titular_cartao"
              id="cpf_titular_cartao"
              color="#333333"
              label="CPF Titular Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={20}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={mTel(data.fone_titular_cartao) || ''}
              style={{ width: 150 }}
              name="fone_titular_cartao"
              id="fone_titular_cartao"
              color="#333333"
              label="Fone Titular Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={14}
              hidden={data.fk_tpf != 1}
            />
          </div>


          <br />
          <div className="defaultHeader">
            <h3>Contratos</h3>
          </div>
          <div className="xButtons">
            <button className="botao" onClick={incluiCto}> {'Incluir'} </button>
          </div>
          <div>
            <br />

            <div className="tableDiv">
              <FrTableReg readOnly={true} startOrder={'asc'} startOrderBy={'pk_cto'} rowsPerPage={10} regName="contratos_empresas" columns={columnsCto} searched={false}
                codeName="pk_cto" page={''} data={dataCto} setModal={setShowModalContratos} setPk_Cto={setPk_Cto} />
            </div>
          </div>

          <div >
            <Dialog aria-labelledby="simple-dialog-title" open={showModalContratos} fullWidth={true} maxWidth={'lg'}>
              <RegContratos setCto={setCto} fk_emp={data.fk_emp} fk_cli={pk_cli} modal={true} setShowModal={setShowModalContratos} />
              <div className="FrModalFooter">
              </div>
            </Dialog>
          </div>

          <div hidden={!showModal}>
            <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'}>
              <RegCliente teste={teste} setShowModal={setShowModal} setShowModalContratos={setShowModalContratos} modal={true} fk_emp={data.fk_emp} />
            </Dialog>
          </div>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contratos_Empresas;